module.exports = __webpack_public_path__ + "static/media/logo.5e7a63b8.png";